import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiCloudOff, FiShield, FiTrash2 } = FiIcons;

const PrivacyItem = ({ icon: Icon, title, description }) => (
  <div className="flex gap-4 p-6 rounded-2xl bg-white/50 border border-white/40 shadow-sm hover:shadow-md transition-shadow">
    <div className="shrink-0 w-10 h-10 rounded-xl bg-aubergine text-white flex items-center justify-center">
      <SafeIcon icon={Icon} className="w-5 h-5" />
    </div>
    <div>
      <h4 className="font-bold text-aubergine mb-1">{title}</h4>
      <p className="text-sm text-muted leading-relaxed">{description}</p>
    </div>
  </div>
);

const PrivacyBand = () => {
  return (
    <section id="privacy" className="py-24 lg:py-32 bg-[#F9F7FA] relative overflow-hidden">
      {/* Decorative Blob */}
      <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-aubergine/[0.03] rounded-full blur-[100px]" />
      
      <div className="w-full max-w-[1120px] mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-[clamp(2.4rem,4vw,3.5rem)] mb-6">Your data belongs <br />to you. Period.</h2>
            <p className="text-lg text-muted mb-8 max-w-[500px]">
              We believe health and spiritual data is the most personal information a person has. Nisaa is built from the ground up to protect that sanctity.
            </p>
            
            <div className="p-8 rounded-[32px] bg-aubergine text-white shadow-2xl relative overflow-hidden">
              <div className="absolute top-0 right-0 p-8 opacity-10">
                <SafeIcon icon={FiShield} className="w-32 h-32" />
              </div>
              <h3 className="text-white text-2xl mb-4">The Nisaa Promise</h3>
              <ul className="space-y-4">
                {[
                  "No third-party trackers or analytics",
                  "No data sharing with advertising networks",
                  "On-device storage by default",
                  "End-to-end encrypted optional backups"
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-white/90">
                    <div className="w-5 h-5 rounded-full bg-rose flex items-center justify-center shrink-0">
                      <SafeIcon icon={FiIcons.FiCheck} className="w-3 h-3 text-white" />
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>

          <div className="grid gap-4 sm:grid-cols-2">
            <PrivacyItem 
              icon={FiCloudOff}
              title="Local First"
              description="Your logs stay on your phone, not our servers, by default."
            />
            <PrivacyItem 
              icon={FiLock}
              title="Encrypted"
              description="Optional cloud sync uses high-grade encryption."
            />
            <PrivacyItem 
              icon={FiTrash2}
              title="Total Deletion"
              description="Wipe your data instantly, whenever you choose."
            />
            <PrivacyItem 
              icon={FiShield}
              title="GDPR Ready"
              description="Built to the highest international privacy standards."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyBand;